import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import addToCart from '../../../utils/cart/addToCart';
import Button from '../../../components/Button';
import Image from '../../../components/Image';
import Price from '../../../components/Price';
import css from './Item.module.scss';
import { getSizeVerbose } from '../../../config/constants-sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

var StyledWithSizeButton = function StyledWithSizeButton(_ref) {
  var _onClick = _ref.onClick,
      size = _ref.size,
      title = _ref.title,
      _ref$variant = _ref.variant,
      available = _ref$variant.available,
      inventoryQuantity = _ref$variant.inventoryQuantity,
      price = _ref$variant.price,
      shopifyId = _ref$variant.shopifyId;
  return /*#__PURE__*/_jsx("button", {
    "aria-label": "Click to add ".concat(title, " in size ").concat(getSizeVerbose(size).toLowerCase(), " to your cart."),
    className: css.sizeButton,
    "data-ov-event": "add-to-bag",
    disabled: !available || inventoryQuantity < 1,
    onClick: function onClick() {
      return _onClick(price, shopifyId);
    },
    type: "button",
    children: size
  });
};

StyledWithSizeButton.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.string.isRequired,
  title: PropTypes.string,
  variant: PropTypes.shape({
    id: PropTypes.string.isRequired,
    available: PropTypes.bool.isRequired,
    inventoryQuantity: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    shopifyId: PropTypes.number.isRequired,
    sku: PropTypes.string.isRequired
  }).isRequired
};

var StyledWithItem = function StyledWithItem(_ref2) {
  var absoluteUrl = _ref2.absoluteUrl,
      image = _ref2.image,
      subtitle = _ref2.subtitle,
      variantStacks = _ref2.variantStacks,
      title = _ref2.title;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      quickAddButtonSoldOut = _useState2[0],
      setQuickAddButtonSoldOut = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showSizes = _useState4[0],
      setShowSizes = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      price = _useState6[0],
      setPrice = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      compareAtPrice = _useState8[0],
      setCompareAtPrice = _useState8[1];

  var quickAddButtonLabel = quickAddButtonSoldOut ? 'Sold Out' : '+ Quick Add';

  var onClickSizeButton = function onClickSizeButton(variantPrice, variantId) {
    setShowSizes(false);
    addToCart({
      price: variantPrice,
      title: title,
      variantId: variantId
    });
  };

  useEffect(function () {
    if (variantStacks.length > 0) {
      var first = variantStacks[0].variant;
      var newCompareAtPrice = first.compareAtPrice,
          newPrice = first.price;
      setPrice(newPrice);
      setCompareAtPrice(newCompareAtPrice);
      var isSoldOut = variantStacks.findIndex(function (_ref3) {
        var _ref3$variant = _ref3.variant,
            available = _ref3$variant.available,
            inventoryQuantity = _ref3$variant.inventoryQuantity;
        return inventoryQuantity >= 1 && available;
      }) === -1;
      setQuickAddButtonSoldOut(isSoldOut);
    }
  }, [variantStacks]);
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("a", {
      className: css.image,
      href: absoluteUrl,
      children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
        alt: "".concat(title, " in the color ").concat(subtitle),
        sizes: [72]
      }))
    }), /*#__PURE__*/_jsxs("div", {
      className: css.text,
      children: [/*#__PURE__*/_jsxs("a", {
        className: css.textLink,
        href: absoluteUrl,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.title,
          children: title
        }), /*#__PURE__*/_jsx("p", {
          className: css.subtitle,
          children: subtitle
        }), price > 0 && /*#__PURE__*/_jsx(Price, {
          className: css.price,
          compareAtPrice: compareAtPrice,
          price: price
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: css.buttons,
        children: [!showSizes && /*#__PURE__*/_jsx(Button, {
          "aria-label": "Select your size and add ".concat(title, " to your cart."),
          bordered: true,
          className: css.quickAddButton,
          disabled: quickAddButtonSoldOut,
          onClick: function onClick() {
            return setShowSizes(true);
          },
          children: quickAddButtonLabel
        }), showSizes && /*#__PURE__*/_jsx("div", {
          className: css.sizeButtons,
          children: variantStacks.map(function (variantStack) {
            return /*#__PURE__*/_createElement(StyledWithSizeButton, _objectSpread(_objectSpread({}, variantStack), {}, {
              key: variantStack.id,
              onClick: onClickSizeButton,
              title: title
            }));
          })
        })]
      })]
    })]
  });
};

StyledWithItem.propTypes = {
  absoluteUrl: PropTypes.string.isRequired,
  image: PropTypes.shape().isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  variantStacks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    size: PropTypes.string.isRequired,
    variant: PropTypes.shape({
      id: PropTypes.string.isRequired,
      available: PropTypes.bool.isRequired,
      compareAtPrice: PropTypes.number.isRequired,
      inventoryQuantity: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      shopifyId: PropTypes.number.isRequired,
      sku: PropTypes.string.isRequired
    }).isRequired
  })).isRequired
};
export default StyledWithItem;